import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a063f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "edit-modal",
  style: {"display":"block"},
  "aria-modal": "true",
  role: "dialog",
  ref: "modalRef"
}
const _hoisted_2 = { class: "edit-modal__dialog" }
const _hoisted_3 = ["title", "aria-label"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "edit-modal__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "modal__close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                  title: _ctx.translate('shop.configuration.Close'),
                  "aria-label": _ctx.translate('shop.configuration.Close')
                }, _hoisted_5, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ])
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}